import { createSlice } from '@reduxjs/toolkit';
import { clearUserData } from '../../actions/userManagementActions';
import {
  cancelStepChangeStatusAllOrders,
  getAllOrders,
  getAllOrdersWithAllFilters,
  hideCancelConfirmation,
  setAllOrdersFiltersByCompany,
  setAllOrdersSortDetails,
  setAllOrdersHasMore,
  setAllOrdersStatus,
} from '../../actions/workQueue/allOrdersActions';

const initialState = {
  sortEnabled: false,
  sortField: 'date',
  sortBy: 'desc',
  data: [],
  pagination: {},
  isLoading: false,
  hasMore: false,
  status: null,
  token: null,
  filters: {
    allOrders: {},
  },
  changeStepStatus: {
    isApiLoading: false,
    status: null,
    token: null,
  },
};

const allOrdersReducer = createSlice({
  name: 'allOrders',
  initialState,
  extraReducers: {
    [getAllOrders.pending]: pending,
    [getAllOrders.fulfilled]: fulfilled,
    [cancelStepChangeStatusAllOrders.pending]: state => {
      state.changeStepStatus.isApiLoading = true;
    },
    [hideCancelConfirmation.type]: state => {
      clearStepStatus(state);
    },
    [cancelStepChangeStatusAllOrders.rejected]: (state, { payload }) => {
      state.changeStepStatus.isApiLoading = false;
      state.changeStepStatus.status = payload.status;
      state.changeStepStatus.token = payload.token;
    },
    [cancelStepChangeStatusAllOrders.fulfilled]: (state, { payload }) => {
      state.changeStepStatus.isApiLoading = false;
      state.changeStepStatus.status = payload.status;
      state.changeStepStatus.token = null;
      const data = [...state.data];
      const orderIndex = data.findIndex(
        o => o.orderId === payload.data.orderId
      );
      data[orderIndex] = payload.data;
      state.data = data;
    },
    [getAllOrdersWithAllFilters.pending]: pending,
    [getAllOrdersWithAllFilters.rejected]: rejected,
    [getAllOrdersWithAllFilters.fulfilled]: fulfilled,
    [clearUserData.type]: state => {
      state.filters.allOrders = {};
    },
    [setAllOrdersFiltersByCompany.type]: (state, { payload }) => {
      state.filters.allOrders[payload.companyId] = payload.filters;
    },
    [setAllOrdersSortDetails]: (state, { payload }) => {
      state.sortEnabled = payload.sortEnabled;
      state.sortBy = payload.sortEnabled ? payload.sortBy : 'desc';
      state.sortField = payload.sortEnabled ? payload.sortField : 'date';
    },
    [setAllOrdersHasMore]: (state, { payload }) => {
      state.hasMore = payload.hasMore;
    },
    [setAllOrdersStatus]: (state, { payload }) => {
      state.status = null;
      state.token = null;
    },
  },
});

function fulfilled(state, { payload }) {
  state.isLoading = false;
  state.data = [
    ...(payload.pagination.pageNumber === 1 ? [] : state.data),
    ...payload.orders,
  ];
  state.pagination = payload.pagination;
  state.hasMore = payload.pagination.pageNumber < payload.pagination.totalPages;
  state.status = null;
  state.token = null;
}

function pending(state, { meta: { arg } }) {
  clearStepStatus(state);
  state.isLoading = true;
  arg.pageNumber === 1 && (() => (state.data = []))();
}

function rejected(state, { payload }) {
  state.isLoading = false;
  state.status = payload.status;
  state.token = payload.token;
  state.hasMore = false;
}

function clearStepStatus(state) {
  state.changeStepStatus.status = null;
  state.changeStepStatus.token = null;
  state.status = null;
  state.token = null;
}

export default allOrdersReducer;
